import { DefaultProductOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getPreviewCardTag = (options: DefaultProductOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const previewCardEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: 'front',
      },
    },
  ];

  const { modal, user } = getModalTag(options.productType, 'Preview Card', previewCardEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
